export function anchor({ text, href, dataX }) {
  return `<a data-x="${dataX}" href="${href}" target="_blank" rel="nooponer">${text}</a>`
}

export function joinWithDash(string) {
  return string.replace(' ', '-')
}
